import { render, staticRenderFns } from "./panel_xizaoka.vue?vue&type=template&id=7d700bb4&scoped=true&"
import script from "./panel_xizaoka.vue?vue&type=script&lang=js&"
export * from "./panel_xizaoka.vue?vue&type=script&lang=js&"
import style0 from "./panel_xizaoka.vue?vue&type=style&index=0&id=7d700bb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d700bb4",
  null
  
)

export default component.exports